import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) { toast.success("Bienvenido"); navigate("/admin"); }
    else toast.error(res.error);
  };

  const inp = "w-full bg-transparent border-b border-border py-3 font-sans text-base text-ink placeholder:text-faint outline-none focus:border-ink transition-colors duration-300";

  return (
    <div className="min-h-screen bg-stone-50 flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-baseline gap-2 justify-center mb-12">
          <span className="font-serif text-3xl text-ink">DOMMAR</span>
          <span className="font-sans text-[10px] tracking-[0.25em] uppercase text-faint">STUDIO</span>
        </Link>
        <h1 className="font-serif text-3xl text-ink text-center mb-2">Acceso al panel</h1>
        <p className="font-sans text-sm text-faint text-center mb-10">Administra el contenido de tu web.</p>
        <form data-testid="login-form" onSubmit={submit} className="space-y-6">
          <input data-testid="login-email" type="email" className={inp} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" type="password" className={inp} placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button data-testid="login-submit" disabled={busy} className="w-full py-3.5 rounded-full bg-ink text-stone-50 font-sans text-sm hover:bg-black transition-colors duration-300 disabled:opacity-50">
            {busy ? "Entrando…" : "Entrar"}
          </button>
        </form>
        <Link to="/" className="block text-center font-sans text-sm text-faint hover:text-ink transition-colors duration-300 mt-8">← Volver al inicio</Link>
      </div>
    </div>
  );
}
